// Webpack imports
import * as bootstrap from 'bootstrap';
import ingredientFilter from "./js/ingredientFilter";

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
            const search = el.querySelector('input');
            if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });
})();

document.addEventListener("DOMContentLoaded", function() {
    const btn_top = document.getElementById('btn-top');
    const ingredientSelect = document.getElementById('ingredient-terms');

    // Hidden navbar on page load
    window.addEventListener('scroll', function() {
        const navbar = document.querySelector('.navbar');
        if (window.scrollY > 50) { // Show the navbar after scrolling 50px
            navbar.classList.add('navbar-visible');
        }
    });

    // Remove the border-bottom class from the last bootstrap-section-block
    const sections = document.querySelectorAll('.section-block-container');
    if (sections.length > 0) {
        const lastSection = sections[sections.length - 1];
        lastSection.classList.remove('border-bottom');
    }

    // Scroll back to top button
    if(btn_top) {
        btn_top.addEventListener('click', function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        });
    }
    
    // Initialize the ingredient filter
    if (ingredientSelect) {
        ingredientFilter(ingredientSelect);
    }
    
    // Image modal
    const modalImage = document.getElementById('modalImage');
    document.querySelectorAll('[data-bs-toggle="modal"]').forEach(trigger => {
        trigger.addEventListener('click', function (event) {
            event.preventDefault();
            
            // Get the href attribute (full-size image URL) of the clicked link.
            const imageSrc = this.getAttribute('href');
            
            // Update the modal's image source.
            modalImage.setAttribute('src', imageSrc);
        });
    });
    
    const modal = document.getElementById('imageModal');
    
    modal.addEventListener('click', function () {
        bootstrap.Modal.getInstance(modal).hide();
    });
});
